module.exports = "<basic-plan-page></basic-plan-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/basic.html
// module id = 1642
// module chunks = 0